import { render, staticRenderFns } from "./CarPoolDetail.vue?vue&type=template&id=644d8cf2&scoped=true&"
import script from "./CarPoolDetail.vue?vue&type=script&lang=js&"
export * from "./CarPoolDetail.vue?vue&type=script&lang=js&"
import style0 from "./CarPoolDetail.vue?vue&type=style&index=0&id=644d8cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644d8cf2",
  null
  
)

export default component.exports